import { createContext } from 'react';
import type { PopupState } from 'material-ui-popup-state/hooks';

interface CascadingMenuContextValue {
  parentPopupState: PopupState | null;
  rootPopupState: PopupState | null;
}

const CascadingMenuContext = createContext<CascadingMenuContextValue>({
  parentPopupState: null,
  rootPopupState: null,
});

export default CascadingMenuContext;
